import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import CKEditor from "react-ckeditor-component";
import { useDispatch, useSelector } from "react-redux";
import {
  addEmailDraft,
  draftEmailById,
  editCustomer,
  emailTemp,
  emailTempByType,
  fileUpload,
  sendEmail,
  sendEmailSubscriber,
} from "../../../store/actions";
import { toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loading from "../../../Common/extra/loading";
import { MenuItem, Select } from "@material-ui/core";
import FileUploader from "./FilePreview";

const SendMailIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editId, type, mailId } = useParams();
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const admin_id = localStorage && localStorage.getItem("id");
  const [state, setState] = useState({
    user_id: "",
    email_content: "",
    userEmail: "",
    email_template_id: 0,
  });
  const userData = useSelector((s) => s?.Customers?.edituser?.data);
  const mailData = useSelector((s) => s?.Customers?.draftEmailById?.data);

  useEffect(() => {
    if (mailData) {
      setState((pre) => ({
        ...pre,
        email_content: mailData?.email_content,
      }));
    }
  }, [mailData]);
  const Templates = useSelector((s) => s?.EmailTemplates?.emailTemplates?.data);
  const [backUrl, setBackUrl] = useState("");
  useEffect(() => {
    if (type) {
      if (type == "facebook") {
        setBackUrl("/facebook-messages");
      } else if (type == "instagram") {
        setBackUrl("/instagram-messages");
      } else if (type == "youtube") {
        setBackUrl("/youtube-messages");
      } else if (type == "twitter") {
        setBackUrl("/twitter-messages");
      } else if (type == "tiktok") {
        setBackUrl("/tiktok-messages");
      }
    }
  }, [type]);

  useEffect(() => {
    dispatch(emailTempByType({ email_template_type: "static" }));
    dispatch(emailTemp({ order: "asc", orderBy: "sort_index" }));
  }, []);

  useEffect(() => {
    if (mailId) {
      dispatch(draftEmailById(mailId));
    }
  }, [mailId]);
  useEffect(() => {
    if (editId) {
      setState((pre) => ({ ...pre, user_id: editId }));
      dispatch(editCustomer(editId));
    }
  }, [editId]);

  useEffect(() => {
    if (userData) {
      setState((pre) => ({
        ...pre,
        userEmail: userData?.amtaxsettlement_data?.Email,
      }));
    }
  }, [userData]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onChange = (evt) => {
    const newContent = evt.editor.getData();
    setState((prevState) => ({
      ...prevState,
      email_content: newContent,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    let formData = new FormData();

    for (let index = 0; index < uploadedFiles.length; index++) {
      formData.append("project_image[]", uploadedFiles[index]);
    }

    const callBack = (url) => {
      const postCallBack = (res) => {
        if (res.detail) {
          toast.success("Email Sent!");
          if (window.location.pathname.includes("detail")) {
            navigate(`/customers/profile/${editId}`);
          } else {
            navigate("/customers");
          }
          setLoading(false);
        } else {
          setLoading(false);
        }
      };

      if (url) {
        dispatch(
          sendEmail(
            {
              user_id: state.user_id,
              email_content: state.email_content,
              email_template_id: state.email_template_id,
              admin_id: admin_id,
              attachments: url.files,
            },
            postCallBack
          )
        );
      }
    };

    const postCallBack = (res) => {
      if (res.detail) {
        toast.success("Email Sent!");
        if (window.location.pathname.includes("detail")) {
          navigate(`/customers/profile/${editId}`);
        } else {
          navigate("/customers");
        }

        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    if (uploadedFiles.length > 0) {
      dispatch(fileUpload(formData, null, callBack));
    } else {
      dispatch(
        sendEmail(
          {
            user_id: state.user_id,
            email_content: state.email_content,
            email_template_id: state.email_template_id,
            admin_id: admin_id,
          },
          postCallBack
        )
      );
    }
  };

  const handleDraftSave = (e) => {
    e.preventDefault();
    setLoading(true);
    let formData = new FormData();

    for (let index = 0; index < uploadedFiles.length; index++) {
      formData.append("project_image[]", uploadedFiles[index]);
    }

    const callback = (url) => {
      const postCallBack = (res) => {
        if (res.data) {
          toast.success("Email Saved as Draft!");
          navigate(`/customers/profile/${editId}`);
          setLoading(false);
        } else {
          setLoading(false);
        }
      };

      if (url) {
        dispatch(
          addEmailDraft(
            {
              receiver_id: state.user_id,
              email_content: state.email_content,
              email_template_id: state.email_template_id,
              attachments: url.files,
              type: "draft",
              sender_id: admin_id,
              status: "1",
            },
            postCallBack
          )
        );
      }
    };

    const postCallBack = (res) => {
      if (res.data) {
        toast.success("Email Saves as Draft!");
        navigate(`/customers/profile/${editId}`);
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    if (uploadedFiles.length > 0) {
      dispatch(fileUpload(formData, null, callback));
    } else {
      dispatch(
        addEmailDraft(
          {
            receiver_id: state.user_id,
            email_content: state.email_content,
            email_template_id: state.email_template_id,
            type: "draft",
            sender_id: admin_id,
            status: "1",
          },
          postCallBack
        )
      );
    }
  };

  const handleSubscriberSubmit = (e) => {
    e.preventDefault();

    const callback = (res) => {
      if (res.detail) {
        toast.success("Email Sent!");
        if (type == "facebook") {
          navigate("/facebook-messages");
        } else if (type == "instagram") {
          navigate("/instagram-messages");
        } else if (type == "youtube") {
          navigate("/youtube-messages");
        } else if (type == "twitter") {
          navigate("/twitter-messages");
        } else if (type == "tiktok") {
          navigate("/tiktok-messages");
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    let body = {
      user_id: state.user_id,
      email_content: state.email_content,
      email_template_id: state.email_template_id,
      admin_id: admin_id,
    };
    dispatch(sendEmailSubscriber({ ...body, subscriber_type: type }, callback));
  };

  const handleCopy = (text) => {
    setState((pre) => ({
      ...pre,
      email_content: state.email_content + text,
    }));
  };

  return (
    <>
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="bg-white px-4 py-3 card-box rounded">
                <Form>
                  <Row>
                    <Col lg="6" className="my-2 doc-select">
                      <div className="py-2 doc-select">
                        <label for="" className="form-label2 m-0">
                          Select Email Template to send Mail
                        </label>
                        <Select
                          className="demo-simple-select-label mt-2"
                          id="demo-simple-select"
                          name="email_template_id"
                          value={state.email_template_id}
                          onChange={handleChange}
                          MenuProps={Templates}
                        >
                          {Templates &&
                            Templates.length > 0 &&
                            Templates.map((item, idx) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </div>
                      <div className="text-center fw-bold my-2">- Or -</div>
                    </Col>
                    {!type && (
                      <Col lg="12" className="my-2">
                        <label for="" className="form-label2 m-0">
                          Use this following Variables to send in email:
                        </label>
                        <label
                          for=""
                          className="form-label2 m-0 col-lg-12 mt-3"
                        >
                          User Variables:
                        </label>
                        <div className="variables-div mt-3 d-flex flex-wrap gap-2">
                          <h5 onClick={() => handleCopy("{{userName}}")}>
                            {"{{userName}}"}
                          </h5>
                          <h5 onClick={() => handleCopy("{{userWorkPhone}}")}>
                            {"{{userWorkPhone}}"}
                          </h5>
                          <h5 onClick={() => handleCopy("{{userCellPhone}}")}>
                            {"{{userCellPhone}}"}
                          </h5>
                          <h5 onClick={() => handleCopy("{{userAddress}}")}>
                            {"{{userAddress}}"}
                          </h5>
                          <h5 onClick={() => handleCopy("{{userDOB}}")}>
                            {"{{userDOB}}"}
                          </h5>
                        </div>
                        <label
                          for=""
                          className="form-label2 m-0 col-lg-12 mt-3"
                        >
                          Admin Variables:
                        </label>
                        <div className="variables-div mt-3 d-flex flex-wrap gap-2">
                          <h5 onClick={() => handleCopy("{{adminName}}")}>
                            {"{{adminName}}"}
                          </h5>
                          <h5
                            onClick={() => handleCopy("{{adminMobileNumber}}")}
                          >
                            {"{{adminMobileNumber}}"}
                          </h5>
                          <h5 onClick={() => handleCopy("{{adminAddress}}")}>
                            {"{{adminAddress}}"}
                          </h5>
                          <h5 onClick={() => handleCopy("{{adminRole}}")}>
                            {"{{adminRole}}"}
                          </h5>
                          <h5
                            onClick={() =>
                              handleCopy("{{adminRolePermission}}")
                            }
                          >
                            {"{{adminRolePermission}}"}
                          </h5>
                        </div>

                        <label
                          for=""
                          className="form-label2 m-0 col-lg-12 mt-3"
                        >
                          Company Variables:
                        </label>
                        <div className="variables-div mt-3 d-flex flex-wrap gap-2">
                          <h5 onClick={() => handleCopy("{{companyName}}")}>
                            {"{{companyName}}"}
                          </h5>
                          <h5 onClick={() => handleCopy("{{companyAddress}}")}>
                            {"{{companyAddress}}"}
                          </h5>
                          <h5
                            onClick={() =>
                              handleCopy("{{companyWebsiteAddress}}")
                            }
                          >
                            {"{{companyWebsiteAddress}}"}
                          </h5>
                          <h5
                            onClick={() =>
                              handleCopy("{{companyEmailSignature}}")
                            }
                          >
                            {"{{companyEmailSignature}}"}
                          </h5>
                        </div>
                        {/* <div className="text-end pe-3 warning-varbles">
                        <span>*Please use this variables with brackets*</span>
                      </div> */}
                      </Col>
                    )}
                    {!type && (
                      <Col lg="12" className="my-2 custom-attach">
                        <label for="" className="form-label2 m-0">
                          Attach File:
                        </label>
                        <FileUploader
                          setUploadedFiles={setUploadedFiles}
                          uploadedFiles={uploadedFiles}
                        />
                      </Col>
                    )}
                    {/* {!type && mailId && (
                      <Col lg="12" className="my-2 custom-attach">
                        {mailData &&
                          mailData.attachments &&
                          mailData.attachments.length > 0 &&
                          mailData.attachments.map((itm) => {
                            return <img src={itm} alt="" />;
                          })}
                      </Col>
                    )} */}
                    <Col lg="12" className="my-2">
                      <label for="" className="form-label2 m-0">
                        Write Mail manually
                      </label>
                      {loading && <Loading className={"cstmLoader"} />}
                      <CKEditor
                        activeClass="p10"
                        content={state.email_content}
                        events={{
                          change: onChange,
                          disabled: true,
                        }}
                      />
                    </Col>
                  </Row>
                </Form>
                <div className="d-flex subscribe-back">
                  <Button
                    onClick={type ? handleSubscriberSubmit : handleSubmit}
                    className="d-flex align-items-center justify-content-center"
                    disabled={
                      state.email_template_id == 0 && state.email_content == ""
                        ? true
                        : false
                    }
                  >
                    Submit
                  </Button>
                  {!type && (
                    <Button
                      onClick={handleDraftSave}
                      className="d-flex align-items-center justify-content-center ms-1"
                      disabled={state.email_content == "" ? true : false}
                    >
                      Save as Draft
                    </Button>
                  )}
                  {type && (
                    <Link
                      className="d-flex btn-2 border align-items-center justify-content-center me-2"
                      to={backUrl}
                    >
                      Back
                    </Link>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default SendMailIndex;
